module.exports = __webpack_public_path__ + "img/velvet.c7de404f.jpg";